import {
	createPageLoadMetric,
	createPageSegmentLoadMetric,
	getWaterfallTimings,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	CONFLUENCE_HOME_LOAD_KEY,
	HOME_OVERVIEW_RECENT_SEGMENT_KEY,
	HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY,
	HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY,
	HOME_RECENTS_VIEW_SEGMENT_KEY,
	HOME_STARRED_VIEW_SEGMENT_KEY,
	HOME_DRAFTS_VIEW_SEGMENT_KEY,
	TASKS_HOME_LOAD_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';
import { HOME_OVERVIEW_FEED_PAGE_SEGMENT } from '@confluence/feed/entry-points/perf.config.ts';

export const HOME_OVERVIEW_RECENT_PAGE_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_OVERVIEW_RECENT_SEGMENT_KEY,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});

export const HOME_OVERVIEW_SPACES_SECTION_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});

export const HOME_RECENTS_VIEW_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_RECENTS_VIEW_SEGMENT_KEY,
});

export const HOME_STARRED_VIEW_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_STARRED_VIEW_SEGMENT_KEY,
});

export const HOME_DRAFTS_VIEW_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_DRAFTS_VIEW_SEGMENT_KEY,
});

export const HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT = createPageSegmentLoadMetric({
	key: HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});

const expectedPageSegments = [
	HOME_OVERVIEW_RECENT_PAGE_SEGMENT,
	HOME_OVERVIEW_FEED_PAGE_SEGMENT,
	HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT,
	HOME_OVERVIEW_SPACES_SECTION_SEGMENT,
];

export const CONFLUENCE_HOME_PAGE_LOAD = createPageLoadMetric({
	key: CONFLUENCE_HOME_LOAD_KEY,
	timings: getWaterfallTimings(expectedPageSegments),
	include: expectedPageSegments,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});

export const TASKS_HOME_PAGE_LOAD = createPageLoadMetric({
	key: TASKS_HOME_LOAD_KEY,
});
